const formatearTelefono = (numero) => {
  const limpio = numero.replace(/\D/g, "");
  return limpio.replace(/(\d{3})(\d{3})(\d{3})/, "$1 $2 $3");
};

const procesarTelefono = (node) => {
  if (!node.classList || !node.classList.contains("wal-drp-phone")) return;

  const textPhone = document.querySelector(".drp-phone");
  const href = node.getAttribute("href");

  // si hay href que empiece por 351
  if (href && href.startsWith("tel:351")) {
    const telefonoSinPrefijo = href.replace(/^tel:351/, "tel:");
    // reemplazamos en href el tel sin 351
    node.setAttribute("href", telefonoSinPrefijo);
    let numeroLimpio = telefonoSinPrefijo.replace("tel:", "");

    if (textPhone) {
      // si existe drp-phone, reemplazamos tambien
      textPhone.textContent = formatearTelefono(numeroLimpio);
    }
  }

  // si existe drp-phone que empiece por 351
  if (textPhone && textPhone.textContent.trim().startsWith("351")) {
    let numeroLimpio = href.replace(/^tel:351/, "").replace("tel:", "");

    // reemplazamos sin 351 cogiendo valor del href
    textPhone.textContent = formatearTelefono(numeroLimpio);
  }
};

const limpiarDrpPhone = (node) => {
  if (!node.classList || !node.classList.contains("drp-phone")) return;

  // Limpiar el href si existe
  const href = node.getAttribute("href");

  if (href && href.startsWith("tel:351")) {
    let numeroLimpio = href.replace(/^tel:351/, "tel:");
    node.setAttribute("href", numeroLimpio);
  }

  let telefonoAct =
    typeof DFI != "undefined" && typeof DFI.telefonoRingPoolActivo == "string"
      ? DFI.telefonoRingPoolActivo
      : href.replace("tel:", "");

  // Limpiar el texto si empieza por 351
  if (node.textContent.trim().startsWith("351")) {
    let numeroLimpio = telefonoAct.trim().replace(/^351/, "");
    node.textContent = formatearTelefono(numeroLimpio);
  }
};

export const initReplacePhone = () => {
  // Observar cambios en #modalFormTelefono y .seoSales
  const modal = document.getElementById("modalFormTelefono");

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      // Nodos añadidos
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          node.querySelectorAll?.(".wal-drp-phone").forEach(procesarTelefono);

          if (
            document.querySelector(".SeoSales") ||
            document.getElementById("btn-nao-cliente-ligar")
          ) {
            document.querySelectorAll(".drp-phone").forEach(limpiarDrpPhone);
          }
        }
      });

      // Cambios en atributos href
      if (mutation.type === "attributes" && mutation.attributeName === "href") {
        procesarTelefono(mutation.target);

        if (
          document.querySelector(".SeoSales") ||
          document.getElementById("btn-nao-cliente-ligar")
        ) {
          document.querySelectorAll(".drp-phone").forEach(limpiarDrpPhone);
        }
      }
    }
  });

  // Observar todo el body
  observer.observe(document.body, {
    childList: true, // Detecta nodos hijos añadidos o eliminados
    subtree: true, // También en todos los descendientes, no solo en el body directo
    attributes: true, // Detecta cambios en atributos
    attributeFilter: ["href"], // Solo detecta cambios en el atributo "href"
  });

  // Revisar elementos ya existentes al inicio
  document.querySelectorAll(".wal-drp-phone").forEach(procesarTelefono);
  if (document.getElementById("btn-nao-cliente-ligar")) {
    document.querySelectorAll(".drp-phone").forEach(limpiarDrpPhone);
  }

  if (modal) {
    const modalObserver = new MutationObserver(() => {
      document.querySelectorAll(".wal-drp-phone").forEach(procesarTelefono);
    });

    modalObserver.observe(modal, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }
};
